<!--index:基础参数管理 2024/09/23 15:19:23 YuAng-->

<template>
  <div v-if="routers.length > 0" class="wrapper">
    <div class="nav-wrap">
      <nav-bar :routers="routers"></nav-bar>
    </div>
    <router-view class="main"></router-view>
  </div>
  <div v-else class="wrapper">
    <div class="no-permission">
      <p>您没有权限访问此页面</p>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'

export default {
  data () {
    return {
      routers: []
    }
  },

  mounted () {
    const menusStr = window.YJ_SCHOOL_STORAGE.getItem('menus')
    // 判断是否存在"基础参数管理"权限
    if (menusStr && menusStr.indexOf('System-Parm-Management') >= 0) {
      this.routers = [
        {
          "path": "/system/parm/level",
          "name": "成绩等级设置"
        },
        {
          "path": "/system/parm/gradeSet",
          "name": "班级报告年级数据显示设置"
        },
        {
          "path": "/system/parm/knowledge",
          "name": "高频错题丶薄弱知识点设置"
        },
        {
          "path": "/system/parm/undulate",
          "name": "波动生丶临界生设置"
        },
        {
          "path": "/system/parm/count",
          "name": "特殊考试参与统计设置"
        },
        {
          "path": "/system/parm/average",
          "name": "平均分计算规则设置"
        },
        {
          "path": "/system/parm/other",
          "name": "其他设置"
        }
      ]
      this.$router.push(this.routers[0].path)
    }
  },

  components: {
    NavBar
  }
}
</script>


<style scoped>
.wrapper {
  display: flex;
  padding-top: 16px;
  font-size: 14px;
}
.main {
  flex: 1;
  min-height: calc(100vh - 260px);
  background: #fff;
  padding: 32px 32px 100px 32px;
  margin-bottom: 20px;
  position: relative;
}
.nav-wrap {
  margin-right: 8px;
  min-width: 200px;
}
</style>